/**
 * Données de référence utilisées par le frontend (selects, validations).
 * Volontairement codées en dur — elles évoluent rarement et ne justifient pas
 * une table. Si elles deviennent dynamiques, on les migrera vers une table
 * d'admin.
 */

// Issus du brief — 28 types de charge.
export const CHARGE_TYPES = [
  'Amortissement',
  "Apport d'affaire",
  'Assurance',
  'Charges commerciales',
  'Cotisations et frais bancaires',
  'Customer Success',
  'Dons',
  'Emprunts bancaires et agios',
  'Entretien et maintenance',
  'Formations internes',
  'Frais de déplacement facturables',
  'Frais internes',
  'Frais de structure',
  'Honoraires',
  'Honoraires de direction',
  'Immobilisations',
  'Impôts et taxes (hors TVA)',
  'Impôts sur les sociétés',
  'Location logiciels',
  'Marketing',
  'Matériel (achat)',
  'Matériel-véhicules-immobilier (location)',
  'Placements',
  'Salaires et charges sociales',
  'Sous-traitance (experts)',
  "Sous-traitance (matériel-lieux-frais d'envoi et/ou impression…)",
  'Télécommunication & poste',
  'TVA',
] as const;

export const PEDAGOGIC_ALLOCATIONS = ['Conseil', 'Formation', 'Sans distinction'] as const;

export const PAYMENT_MODES = ['Virement', 'Prélèvement', 'CB', 'Paypal'] as const;

export const BANKS = ['BNP', 'CIC', 'LCL', 'QONTO'] as const;

export const COUNTRIES = ['FR', 'UE', 'HORS_UE'] as const;

export const EXPENSE_TYPES = ['transport', 'hebergement', 'postal', 'autre'] as const;

/**
 * Comptes analytiques. Le brief mentionne un CSV de 288 entrées non fourni.
 * On démarre avec ceux référencés dans les fournisseurs pré-configurés et on
 * complétera quand le CSV sera disponible.
 *
 * TODO: importer Liste_des_comptes_analytiques.csv (288 comptes) via un
 *       script scripts/import-accounts.ts quand le CSV sera fourni.
 */
export const ACCOUNTS: ReadonlyArray<{ code: string; label: string }> = [
  { code: '61320000', label: 'Locations immobilières' },
  { code: '61350000', label: 'Locations logiciels & matériel informatique' },
  { code: '62260000', label: 'Honoraires' },
  { code: '62560000', label: 'Frais de déplacement' },
  { code: '62700000', label: 'Services bancaires et assimilés' },
];

export const REFERENCE_DATA = {
  charge_types: CHARGE_TYPES,
  pedagogic_allocations: PEDAGOGIC_ALLOCATIONS,
  payment_modes: PAYMENT_MODES,
  banks: BANKS,
  countries: COUNTRIES,
  expense_types: EXPENSE_TYPES,
  accounts: ACCOUNTS,
} as const;
